import { Dictionary } from "../../../../../types";
import { StoreFeature } from "../../../core/store/types";

export interface Template extends Dictionary<string, any>
{
    typeIdentifier: string;
    slots: string[];
}

export const template: StoreFeature<Template> = {};